import { Link } from 'react-router-dom'
import React from 'react'
import useMediaQuery from "../hooks/useMediaQuery";
import {useState} from 'react';
import {AiOutlineMenu,AiFillCloseCircle} from 'react-icons/ai';

function Navbar({setSelectedPage,selectedPage}) {
    const isDesktop = useMediaQuery("(min-width: 768px)");
    const [isMenuToggled, setIsMenuToggled] = useState(false);
    

  return (
    <nav className={` z-40 w-full fixed top-0 py-6  bg-violet-400 `}>
     <div className=" flex items-center justify-between mx-auto w-5/6">
        <h4 className="font-playfair text-3xl font-bold text-white">SOS</h4>
 
       {isDesktop ? (
        <div className="flex justify-between gap-16 font-opensans text-sm font-semibold">
        <Link className={selectedPage==="home" ? 'text-yellow-400': 'text-white'} to='/'  onClick={() => setSelectedPage('home')}>Home</Link>
        <Link className={selectedPage==="leagues" ? 'text-yellow-400': 'text-white'} to='/leagues' onClick={() => setSelectedPage('leagues')} >Leagues</Link>
        <Link className={selectedPage==="teams" ? 'text-yellow-400': 'text-white'} to='/teams' onClick={() => setSelectedPage('teams')}>Teams</Link>
        <Link className={selectedPage==="players" ? 'text-yellow-400': 'text-white'} to='/players' onClick={() => setSelectedPage('players')} >Players</Link>
      </div>
       ) : (
        <button
        className="rounded-full bg-red p-2"
        onClick={() => setIsMenuToggled(!isMenuToggled)}
      >
        <AiOutlineMenu className=' text-white'/>
        </button>
       )}


       {/* MOBILE MENU POPUP */}
       {!isDesktop && isMenuToggled && (
          <div className="fixed right-0 bottom-0 h-full w-[300px]  bg-violet-400">
            {/* CLOSE ICON */}
            <div className="flex justify-end p-12">
              <button onClick={() => setIsMenuToggled(!isMenuToggled)}>
                <AiFillCloseCircle className=' text-yellow-400'/>
              </button>
            </div>

            {/* MENU ITEMS */}
            <div className="flex flex-col gap-10 ml-[33%] text-2xl text-blue">
     
            <Link className={selectedPage==="home" ? 'text-yellow-400': 'text-white'} to='/'  onClick={() => setSelectedPage('home')} >Home</Link>
            <Link className={selectedPage==="leagues" ? 'text-yellow-400': 'text-white'} to='/leagues' onClick={() => setSelectedPage('leagues')} >Leagues</Link>
            <Link className={selectedPage==="teams" ? 'text-yellow-400': 'text-white'} to='/teams' onClick={() => setSelectedPage('teams')}>Teams</Link>
            <Link  className={selectedPage==="players" ? 'text-yellow-400': 'text-white'} to='/players' onClick={() => setSelectedPage('players')}>Players</Link>

            </div>
          </div>
        )}
        
     </div>
  
    
   </nav>
  )
}

export default Navbar